// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"11bc091b","455":"31fea4bf"}[chunkId] + ".chunk.js";
};